import { styled } from '@material-ui/core/styles';
import Link from './Link';

const LinkBlack = styled(Link)({
  color: 'black'
});

export default LinkBlack;